const navItems = [
  { id: 'home', label: 'Home', path: '/' },
  { id: 'about', label: 'About', path: '/about' },
  { id: 'programmes', label: 'Programmes', path: '/programmes' },
  { id: 'impact', label: 'Impact', path: '/impact' },
  { id: 'sdg', label: 'SDG Goals', path: '/sdg' },
  { id: 'blog', label: 'Blog', path: '/blog' },
  { id: 'contact', label: 'Contact', path: '/contact' },
];

export default navItems;
